import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="pricing-toggle"
// Handles both:
// 1. Monthly/annual pricing toggle on pricing page
// 2. Flat rate/per sqft toggle on service forms
export default class extends Controller {
  static targets = [
    // Pricing page targets
    "toggle", "monthly", "annual", "periodInput", "monthlyLabel", "annualLabel",
    // Service form targets (legacy)
    "selector", "flatRate", "perSqft"
  ]

  connect() {
    // Initialize based on which targets are present
    if (this.hasToggleTarget) {
      this.updatePricingDisplay()
    } else if (this.hasSelectorTarget) {
      this.toggleServicePricing()
    }
  }

  // Called when user interacts with toggles
  toggle() {
    if (this.hasToggleTarget) {
      this.updatePricingDisplay()
    } else if (this.hasSelectorTarget) {
      this.toggleServicePricing(true) // Clear values when user explicitly changes
    }
  }

  updatePricingDisplay() {
    const isAnnual = this.toggleTarget.checked

    // Update all monthly/annual price displays
    this.monthlyTargets.forEach(el => {
      el.classList.toggle("hidden", isAnnual)
    })

    this.annualTargets.forEach(el => {
      el.classList.toggle("hidden", !isAnnual)
    })

    // Update hidden period inputs in forms
    this.periodInputTargets.forEach(input => {
      input.value = isAnnual ? "annual" : "monthly"
    })

    // Update label styling
    if (this.hasMonthlyLabelTarget) {
      this.monthlyLabelTarget.classList.toggle("bg-white", !isAnnual)
      this.monthlyLabelTarget.classList.toggle("text-gray-900", !isAnnual)
      this.monthlyLabelTarget.classList.toggle("shadow-sm", !isAnnual)
      this.monthlyLabelTarget.classList.toggle("text-gray-600", isAnnual)
    }

    if (this.hasAnnualLabelTarget) {
      this.annualLabelTarget.classList.toggle("bg-white", isAnnual)
      this.annualLabelTarget.classList.toggle("text-gray-900", isAnnual)
      this.annualLabelTarget.classList.toggle("shadow-sm", isAnnual)
      this.annualLabelTarget.classList.toggle("text-gray-600", !isAnnual)
    }
  }

  // Flat rate/per sqft toggle for service forms (legacy support)
  // Called from connect() with clearValues=false, from user action with clearValues=true
  toggleServicePricing(clearValues = false) {
    if (!this.hasSelectorTarget) return

    const selectedValue = this.selectorTarget.value

    if (selectedValue === "flat_rate") {
      // Show flat rate price, hide per sqft
      this.flatRateTarget.classList.remove("hidden")
      this.perSqftTarget.classList.add("hidden")

      // Only clear when user explicitly changes the pricing model
      if (clearValues) {
        const perSqftInput = this.perSqftTarget.querySelector('input[type="number"]')
        if (perSqftInput) {
          perSqftInput.value = ""
        }
      }
    } else if (selectedValue === "per_sqft") {
      // Hide flat rate price, show per sqft
      this.flatRateTarget.classList.add("hidden")
      this.perSqftTarget.classList.remove("hidden")

      // Only clear when user explicitly changes the pricing model
      if (clearValues) {
        const flatRateInput = this.flatRateTarget.querySelector('input[type="number"]')
        if (flatRateInput) {
          flatRateInput.value = ""
        }
      }
    }
  }
}
